import React from 'react';
import { Button } from '@insurancemenu/imenu-components-lib';
import clsx from 'clsx';
import { createStyles } from './styles';

interface Props {
  title: string;
  text: string;
  actionButtonText?: string;
  className?: string;
  onAction?: () => void;
}

const DisclaimerComponent: React.FC<Props> = ({ title, text, actionButtonText, className, onAction }) => {
  const classes = createStyles();

  return (
    <section className={clsx(classes.disclaimerPanel, className)}>
      <h1 className={classes.title}>{title}</h1>
      <h3 className={classes.text}>{text}</h3>
      {actionButtonText && (
        <div className={classes.buttonSection}>
          <Button type="outlined" color="primary" size="large" onClick={onAction}>
            {actionButtonText}
          </Button>
        </div>
      )}
    </section>
  );
};

export default DisclaimerComponent;
